export const totalDistance = (cash: any, onePay: any, returnOrder: any): number => {
  const totalCash = Array.isArray(cash)
    ? cash.reduce((acc, value) => acc + parseFloat(value), 0)
    : 0;

  const totalOnePay = Array.isArray(onePay)
    ? onePay.reduce((acc, value) => acc + parseFloat(value), 0)
    : 0;

  const totalReturn = Array.isArray(returnOrder)
    ? returnOrder.reduce((acc, value) => acc + parseFloat(value), 0)
    : 0;

  const totalSum = totalCash + totalOnePay + totalReturn;
  const roundedTotal = totalSum.toFixed(2);
  return parseFloat(roundedTotal);
};
